// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2P-VY","author":"Table_author__3CPvf","authorImage":"Table_authorImage__3EgOy","unreadRow":"Table_unreadRow__2FXQD"};